export default __webpack_public_path__ + "static/media/Z2CGoldBadge1stWeek.6fb26d51.png";